export const tariffKeys = {
  all: ['tariffs'] as const,
  type: (type: string) => [...tariffKeys.all, 'type', type] as const,
  typeWithSearch: (type: string, search?: string) =>
    [...tariffKeys.type(type), 'search', search ?? ''] as const,
};
